import { render, staticRenderFns } from "./collaborations.vue?vue&type=template&id=5b87508e"
import script from "./collaborations.vue?vue&type=script&lang=js"
export * from "./collaborations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports